<div class="input-container">
  <input
    type="text"
    [(ngModel)]="message"
    (keydown)="onKeyDown($event)"
    [disabled]="sending"
    placeholder="Escribe un mensaje..."
    class="chat-input"
  />
  <div *ngIf="sending" class="sending-spinner">
    <mat-spinner diameter="24"></mat-spinner>
  </div>
  <button *ngIf="!sending" mat-icon-button (click)="sendMessage()" [disabled]="!message.trim()">
    <mat-icon>send</mat-icon>
  </button>
</div>
